import React from "react";

import { Button } from "@mui/material";

import { BaseButtonProps } from "./base/types";

export const ContainedButton: React.FC<BaseButtonProps> = ({
  text,
  ...props
}) => {
  return <Button {...props}>{text}</Button>;
};
